import { render, staticRenderFns } from "./SmsProvider.vue?vue&type=template&id=3b82409e&scoped=true"
import script from "./SmsProvider.vue?vue&type=script&lang=js"
export * from "./SmsProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b82409e",
  null
  
)

export default component.exports